<template lang="pug">
div
  app-modal-avocar(
    v-if="showModalAvocar && idsProcessos.length > 0",
    @closeModal="closeModalAnocar",
    :idsProcessos="idsProcessos"
  )
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :showOs="true",
      :showMunicipios="true",
      :configuracaoFiltro="configuracaoFiltro",
      :filtroRapido="filtroRapido"
    )
  app-listagem(
    :hasActionButtonAvocar="true",
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :infoPrazos="infoPrazos",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :disableButtonAvocar="idsProcessos.length === 0",
    :hasFiltroRapido="true",
    :filtro="filtro",
    @atualizarFiltro="atualizarFiltro",
    @avocar="avocarVarios",
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selected="false",
    @selectItem="itemSelecionado"
  )
</template>

<script>
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppModalAvocar from '@/screens/analise/components/modal/AppModalAvocar'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default
const { filtro } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalAvocar,
    AppModalVisualizarCompleto
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('AVOCAR_PROCESSO'),
      isAp: process.env.ESTADO === 'ap',
      items: [],
      idProcesso: null,
      tipoProcesso: null,
      numeroProcesso: '',
      protocolo: '',
      infoPrazos: undefined,
      setoresInfoVencimento: [ 'GAC', 'GEO', 'GCG', 'CGIR', 'DEAF', 'GDA', 'GRF', 'GAM', 'GEA', 'DJ', 'CDI', 'CPAV', 'GP', 'GIT', 'GRF_CAF',
        'GCG_CGIR'],
      showModalVisualizarProcesso: false,
      showModalAvocar: false,
      totalElements: 0,
      processosSelecionados: [],
      showModalResponsavel: false,
      processoTrocado: null,
      idsProcessosAssinatura: [],
      idsProcessos: [],
      showModalAssinatura: false,
      configuracaoFiltro: {
        filtroSituacao: filtro?.filtroSituacao?.AVOCAR_PROCESSO || []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], marcado: () => true, type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Município', propriedade: 'municipio', sortable: true, ordem: 3, acoes: [] },
        { id: 5, titulo: 'Responsável', propriedade: 'responsavel', ordem: 5, acoes: [] },
        { id: 6, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 7, titulo: 'Data de vencimento', propriedade: 'dataVencimento', ordem: 5, acoes: [], isPrazo: true, exibir: () => this.showInfoVencimento() },
        { id: 3, titulo: 'Situação', propriedade: 'status', ordem: 4, acoes: [], exibir: () => this.showStatus() },
        {
          id: 9, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso },
            { id: 2, nome: 'Avocar Processo', icone: 'fa-file', codigo: 'AVOCAR_PROCESSO', ordem: 2, show: this.showAvocarProcesso }
          ]
        }
      ],
      filtroRapido: null
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  methods: {
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },
    AVOCAR_PROCESSO (_this, { item }) {
      this.idsProcessos = [item.id]
      this.showModalAvocar = true
    },
    itemSelecionado (processo) {
      if (!this.idsProcessos.find(p => p === processo.id)) {
        this.idsProcessos.push(processo.id)
        this.items.map((i) => {
          if (i.id === processo.id) {
            i.selecionado = true
          }
        })
      } else {
        this.idsProcessos = this.idsProcessos.filter(p => p !== processo.id)
        this.items.map((i) => {
          if (i.id === processo.id) {
            i.selecionado = false
          }
        })
      }
    },
    avocarVarios () {
      this.showModalAvocar = true
    },
    atualisaItems (items) {
      this.items = items
    },
    closeModalAnocar () {
      if (this.idsProcessos.length === 1) {
        this.idsProcessos = []
        this.items.map((i) => {
          i.selecionado = false
        })
      }
      this.showModalAvocar = false
    },
    atualizarFiltro (novoFiltro) {
      this.filtroRapido = novoFiltro
    },
    showInfoVencimento () {
      return !!this.setoresInfoVencimento.find(setor => setor === this.usuario?.perfilSelecionado?.setor?.codigo)
    },
    showStatus () {
      return !!this.isAp
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaAvocarProcessoListagem.vue